module.exports = __webpack_public_path__ + "static/media/add4.3d174c8c.png";